
const config = {
    host: 'http://localhost:3001',
    imgHost: 'http://localhost:3001/'
}

export default config;